import {FRACTION_DIGITS} from "../constants/returns-constants";

export const getFormattedPrice = (price) => {
  price = price ? `$${price.toFixed(FRACTION_DIGITS)}` : '';

  return price
};